<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_salud_1_mes_gratis.jpg" style="width: 100%" />
    <p class="tituloTarjeta">CUIDA DE TU FAMILIA DESDE HOY</p>
    <p>
      Lo primero es tu familia y lo segundo su salud.
      Contrata ahora nuestro <b> Seguro de Salud</b> y <b> llévate 1 mes gratis</b>:
    </p>
    <ul style="list-style-type: disc">
      <li>Cuadro médico amplio</li>
      <li>Atención médica rápida y sin esperas</li>
      <li>Plataforma de telemedicina con chat médico y videoconsulta</li>
      <li>Asistencia sanitaria en viajes</li>
    </ul>
    <p>
      <b>Cuidarte es quererte</b> 
    </p>
        <p class="container-flex">
      <a :href="'tel:' + telefonoOwner" v-if="visibleBotonLlamar">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llamar oficina
        </button>
      </a>
    </p>

  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },

  computed: {
    visibleBotonLlamar() {
      return (
         !this.$store.state.portfolio.cliente.ownerPropioClienteCanalTelefonico
      );
    }
  }

};


</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>